export default __webpack_public_path__ + "static/aboutUs_2@2x-d241f56bbefa36ad4473c6a0c4e28828.jpg";